import { render } from "./indexProposalComponent.vue?vue&type=template&id=9f343ea0&scoped=true"
import script from "./indexProposalComponent.vue?vue&type=script&lang=js"
export * from "./indexProposalComponent.vue?vue&type=script&lang=js"

import "./indexProposalComponent.vue?vue&type=style&index=0&id=9f343ea0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f343ea0"]])

export default __exports__